module.exports = __webpack_public_path__ + "img/BPJS-Logo.70c87fef.png";